import { isActionOf } from "typesafe-actions";
import { from, filter, switchMap, map } from "rxjs";
import {  getContrctorDashboardAction } from "./actions";
import { ROUTES } from "../../../history";
import { RootEpic } from "../../../store/epics";



const getContractorDashboardEpic: RootEpic = (action$, _, {api} ) =>
    action$.pipe(
        filter(isActionOf(getContrctorDashboardAction.request)),
        switchMap(() => {
            return from(api.getDashboard())
            .pipe(
                map(res => {
                    if(res.code === 200) {
                        return getContrctorDashboardAction.success(res.data!);
                    }
                    if(res.code === 400 || res.code === 401) {
                        window.location.pathname = ROUTES.CONTRACTOR_AUTH;
                        
                    }
                    return getContrctorDashboardAction.failure(res);
                })
            )
        })
    )



const ContractorDashboardEpics = [
    getContractorDashboardEpic
  
];

export default ContractorDashboardEpics;
